import { CommonModule, isPlatformServer } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  standalone: true,
  selector: 'pm-link',
  imports: [CommonModule, RouterLink],
  templateUrl: './pm-link.component.html',
  styleUrl: './pm-link.component.scss',
})
export class PmLinkComponent {
  @Input({ required: true }) route!: string;
  @Input() external = false;
  @Input() disabled = false;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  onOpenExternalLink() {
    if (!this.external) return;
    if (isPlatformServer(this.platformId)) return;

    window.open(this.route, '_blank');
  }
}
